import TikTokAuthorisationButton from '../../components/authorise/platforms/TikTokAuthorisationButton'
import { AccountOnboardingLayout } from '../../containers/AccountOnboardingLayout'

type NewTikTokAccountPageProps = {
    isAdsPage?: boolean
}

function NewTikTokAccountPage({ isAdsPage }: NewTikTokAccountPageProps) {
    return (
        <AccountOnboardingLayout
            title={isAdsPage ? 'Add a TikTok Ad Account' : 'Add a TikTok User profile'}
        >
            <p>To add a TikTok account please:</p>
            <ol>
                <li>ensure you are logged into the TikTok profile you want to add</li>

                <li>click the button below</li>
            </ol>
            <TikTokAuthorisationButton isAdsPage={isAdsPage} />
        </AccountOnboardingLayout>
    )
}

export default NewTikTokAccountPage
